import React from "react";
import { Box, Button, Heading, Text } from "grommet";
import AInstCard from "./AInstCard";

const InstList = (props: any) => {
    // console.log('InstList', props)
    const instData = props.instData;
    return (
        <>
            {instData ? (
                <Box
                    width="full"
                    height="full"
                    overflow="auto"
                    pad="10px"
                    background="rgba(255,255,255,0.8)"
                    align="start"
                    justify="start"
                >
                    {instData.map((p: any) => (
                        <AInstCard
                            key={p.inst.inst_id}
                            inst={p.inst}
                            names={p.names}
                        />
                    ))}
                </Box>
            ) : (
                <Box
                    width="full"
                    height="full"
                    overflow="auto"
                    pad="10px"
                    background="rgba(255,255,255,0.8)"
                    align="center"
                    justify="center"
                >
                    <Text size="14px"> 기관 목록 </Text>
                </Box>
            )}
        </>
    );
};

export default InstList;
